module.exports = __webpack_public_path__ + "static/media/loading.b18cc02a.svg";